<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>

<div class="container">
  <div class="row sura-main-container__container-row justify-content-center">
    <div
      class="col-12 col-sm-8 text-primary-emphasis fw-bolder text-center mb-3 sura-main-container__hero-title d-flex flex-column"
    >
      <div class="order-1 order-sm-0">
        <div class="order-0 order-sm-1">
          <img
            src="./assets/img/Pago_rechazado.png"
            loading="lazy"
            alt="seguro de moto precio"
            class="imagen"
          />
        </div>
        <h3>Tu pago ha sido rechazado</h3>
        <div class="content">
          <span class="information_text"
            >Tu pago por ${{
              this.valorAPagar| customNumberFormat
            }}
            no se ha completado. Por favor, verifica tus datos de pago e
            inténtalo nuevamente.</span
          >
        </div>
      </div>

      <a (click)="redirect()" class="sura-btn order-3">Intentar de nuevo</a>
    </div>
  </div>
</div>

<div class="textoArriba">
  <app-footer-app class="footer-fixed" />
</div>
